import { useEffect, useState } from 'react';

import { GlobalStylesVisid } from '@monetization/hpaip-components-library';
const {
  layout: { breakpoint0, breakpoint2 },
} = GlobalStylesVisid;
const BREAKPOINT_SMALL_MOBILE = 430;
const BREAKPOINT_MOBILE = breakpoint0;
const BREAKPOINT_TABLET = breakpoint2;

export type ViewSize = {
  isSmallMobile: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};
const useCheckViewSize = () => {
  const [viewSize, setViewSize] = useState<ViewSize>({
    isSmallMobile: false,
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });
  useEffect(() => {
    const checkViewSize = () => {
      if (window.innerWidth <= BREAKPOINT_SMALL_MOBILE) {
        setViewSize({
          isSmallMobile: true,
          isMobile: true,
          isTablet: false,
          isDesktop: false,
        });
      } else if (window.innerWidth <= BREAKPOINT_MOBILE) {
        setViewSize({
          isSmallMobile: false,
          isMobile: true,
          isTablet: false,
          isDesktop: false,
        });
      } else if (window.innerWidth < BREAKPOINT_TABLET) {
        setViewSize({
          isSmallMobile: false,
          isMobile: false,
          isTablet: true,
          isDesktop: false,
        });
      } else {
        setViewSize({
          isSmallMobile: false,
          isMobile: false,
          isTablet: false,
          isDesktop: true,
        });
      }
    };

    // to ensure the sizes are correct on first render
    checkViewSize();

    window.addEventListener('resize', checkViewSize);
    return () => window.removeEventListener('resize', checkViewSize);
  }, []);

  return viewSize;
};

export default useCheckViewSize;
